import type { UpdateCourseDraftBodyLevel } from './updateCourseDraftBodyLevel';
import type { UpdateCourseDraftBodyPrice } from './updateCourseDraftBodyPrice';
import type { UpdateCourseDraftBodySectionsItem } from './updateCourseDraftBodySectionsItem';

export type UpdateCourseDraftBody = {
  /**
   * 강의 설명
   * @nullable
   */
  description?: string | null;
  /**
   * 강의 난이도
   * @nullable
   */
  level?: UpdateCourseDraftBodyLevel;
  /** @nullable */
  price?: UpdateCourseDraftBodyPrice;
  /**
   * 강의 커리큘럼 구조(섹션 및 강의 목록).
각 요소는 'SectionDraftDetail' 스키마를 따르며, 각 섹션 내의 강의는 'LectureDraftDetail' 스키마를 따릅니다.
새 강의의 경우 'LectureDraftDetail' 내에 'markdownContent'를 포함하여 초기 마크다운을 설정할 수 있습니다.
기존 강의의 마크다운 업데이트 및 모든 강의의 마크다운 추가/변경은 전용 API를 사용해야 합니다.
   * @nullable
   */
  sections?: UpdateCourseDraftBodySectionsItem[] | null;
  /**
   * 썸네일 이미지 URL. 썸네일을 변경하려면 먼저 해당 이미지를 업로드하고 그 URL을 사용합니다. null로 설정 시 썸네일 제거 가능.
   * @nullable
   */
  thumbnailUrl?: string | null;
  /** 강의 제목 */
  title: string;
};
